<template>
  <div class="locale-switcher">
    <div class="country-code" ref="countryCode">
      <div>
        {{ $i18n.locale | capitalize }}
      </div>

      <div class="icon" :class="toggleIconClasses">
        <icon-arrow-down-bold height="12" width="12"/>
      </div>
    </div>

    <div class="dropdown-menu" ref="localesList">
      <div
        v-for="(label, countryCode, index) in supportedLocales"
        class="dropdown-menu-item"
        :key="index"
      >
        <div class="dropdown-menu-item-label">
          {{ label }}
        </div>

        <div class="dropdown-menu-item-icon">
          <base-checkbox
            :value="currentLocale === countryCode"
            @input="updateLocale(countryCode)"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import tippy from 'tippy.js'
  import supportedLocales from '@/constants/supportedLocales'

  export default {
    data: () => ({
      supportedLocales,
      isOpen: false
    }),

    mounted() {
      this.initCountryListDropdown()
    },

    computed: {
      currentLocale() {
        return this.$i18n.locale
      },

      toggleIconClasses() {
        return {
          'is-open': !this.isOpen
        }
      }
    },

    methods: {
      initCountryListDropdown() {
        tippy(this.$refs.countryCode,  {
          allowHTML: true,
          content: this.$refs.localesList,
          trigger: 'click',
          hideOnClick: true,
          interactive: true,
          theme: 'custom-light',
          placement: 'bottom',
          animation: 'shift-away',
          arrow: true,
          inertia: true,
          duration: [400, 300],
          onShow: () => {
            this.isOpen = true
          },
          onHide: () => {
            this.isOpen = false
          }
        })
      },

      updateLocale(locale) {
        this.$i18n.locale = locale
        this.setLocale(locale)
        tippy.hideAll()
      },

      ...mapActions('auth', {
        setLocale: 'setLocale',
      })
    }
  }
</script>

<style lang="scss" scoped>
  .country-code {
    height: 35px;
    width: 85px;

    display: flex;
    align-items: center;
    justify-content: space-evenly;

    border: 1.5px solid #fff;
    border-radius: 6px;
    color: #fff;
    cursor: pointer;

    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 21px;
  }

  .icon {
    display: flex;
    align-items: center;
    justify-content: center;

    width: 12px;
    height: 12px;

    transition: transform 0.2s ease;
  }

  .is-open {
    transform: rotate(-90deg);
  }
</style>